import { TranslatedText } from "@/components/common/text";

export const ChatAssistantEmpty = () => {
    return (
        <div className="flex flex-1 flex-col items-center justify-center gap-2 px-[72px] py-10 text-center">
            <div className="h-12 w-12 rounded-full bg-cm-p-accent-50" />
            <span className="text-cm-p-text-primary text-base font-medium">
                <TranslatedText>How can I help?</TranslatedText>
            </span>
            <p className="text-cm-p-text-secondary text-sm">
                <TranslatedText>
                    Conversation content will go here. Ask questions about your trucks, loads, or strategy and the assistant will respond.
                </TranslatedText>
            </p>
        </div>
    );
};
